import Lottie from 'lottie-react';

import emptyDegrees from '../jsons/empty-degrees.json';

const EmptyDegrees = props => {
  return <Lottie loop={false} animationData={emptyDegrees} {...props} />;
};

export default EmptyDegrees;
